import React, { useCallback } from 'react';
import { ChevronLeftIcon } from '../themes/icons/ChevronLeftIcon';
import { ChevronRightIcon } from '../themes/icons/ChevronRightIcon';
import { useProfile } from '../hooks/UseProfile';
import { makeStyles } from '@material-ui/core';
import classnames from 'classnames';

const useStyles = makeStyles({
  toggleButton: {
    backgroundColor: 'white',
    height: '40px',
    cursor: 'pointer',
    position: 'fixed',
    bottom: '15px',
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    borderRight: '1px solid rgba(0, 0, 0, 0.12)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'width 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms'
  },
  toggleButtonActive: {
    width: '272px'
  },
  toggleButtonInactive: {
    width: '48px'
  },
  version: {
    display: 'flex',
    width: 'inherit',
    bottom: '1px',
    position: 'fixed',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#9E9E9E',
    fontSize: '10px',
    fontFamily: 'Segoe UI',
    borderRight: '1px solid rgba(0, 0, 0, 0.12)',
    backgroundColor: 'white',
    height: '16px'
  },
  chevron: {
    color: '#757575',
    transform: 'scale(0.7)'
  },
  bottomIcon: {
    lineHeight: '40px'
  }
});

export const CollapseButton = props => {
  const { profile } = useProfile();
  const classes = useStyles();

  const shouldDisplayVersion = useCallback(() => {
    if (
      props.open &&
      profile &&
      (profile.userType === 'SUPER_ADMIN' || profile.userType === 'FUND_ADMIN')
    ) {
      return `${process.env.REACT_APP_VERSION} ${process.env.REACT_APP_BUILD_NUMBER}`;
    }
  }, [profile, props.open]);

  return (
    <div
      data-testid="clickable div"
      className={classnames(
        classes.toggleButton,
        props.open ? classes.toggleButtonActive : classes.toggleButtonInactive
      )}
      onClick={() => props.setVisibility(!props.open)}
    >
      <div className={classes.bottomIcon}>
        {props.open ? (
          <ChevronLeftIcon className={classes.chevron} />
        ) : (
          <ChevronRightIcon className={classes.chevron} />
        )}
      </div>
      <div className={classes.version}>{shouldDisplayVersion()}</div>
    </div>
  );
};
